var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6.24542V19.2638C20 19.6687 19.6779 20 19.2842 20H4.61056C4.21688 20 3.89478 19.6687 3.89478 19.2638V15.5828C3.89478 15.1779 4.21688 14.8466 4.61056 14.8466C5.00425 14.8466 5.32635 15.1779 5.32635 15.5828V18.5276H18.5684V7.8405C18.5326 7.85275 18.4849 7.85275 18.4491 7.85275H13.3193C12.9256 7.85275 12.6035 7.52146 12.6035 7.11656V1.47239H5.32635V8.95705C5.32635 9.36196 5.00425 9.69324 4.61056 9.69324C4.21688 9.69324 3.89478 9.36196 3.89478 8.95705V0.736197C3.89478 0.331289 4.21688 0 4.61056 0H13.5221C13.7011 0 13.88 0.0736197 14.0113 0.196305L19.7734 5.70553C19.9165 5.84051 20 6.03681 20 6.24542ZM14.0351 6.3804H18.3656L14.0351 2.23314V6.3804Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9649C0 12.3696 0.325396 12.7007 0.723103 12.7007H10.2554L7.92944 14.81C7.62817 15.0797 7.60405 15.5458 7.86917 15.8523C8.01379 16.0117 8.20661 16.0976 8.4115 16.0976C8.58024 16.0976 8.74893 16.0363 8.89355 15.9137L12.6537 12.5045C12.8103 12.3696 12.8947 12.1611 12.8947 11.9526C12.8947 11.7441 12.8104 11.5479 12.6537 11.4008L8.8936 7.99161C8.59232 7.72183 8.13434 7.74633 7.86921 8.05294C7.60409 8.35951 7.62817 8.82553 7.92949 9.0953L10.2916 11.2291H0.723103C0.325396 11.2291 0 11.5602 0 11.9649Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/export.e18a0917.svg";
export { ForwardRef as ReactComponent };